const makeSelectize = require('./makeSelectize.js');

function makeSelectizeOnEach(selector) {
  const selects = $(selector);
  if (selects.length) {
    selects.each(function(n, el) {
      if (!el.selectize && el.tagName.toLowerCase() === 'select') {
        makeSelectize(el, null, el.dataset.selectizeCanAdd);
      }
    });
  }
}

module.exports = makeSelectizeOnEach;
